exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".autoWidth[data-v-aa7537e2]{width:100% !important;max-width:none !important}\n", ""]);

